<template>
  <div class="section pt-5">
    <bed-datatable ref="bed_datatable"></bed-datatable>
  </div>
</template>

<script>
import { get, error_message } from "@/utils";
import BedDatatable from "./bed_datatable/Index.vue";

export default {
  name: "PatientBeds",
  components: { BedDatatable },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
